import React, { useEffect, useState, useRef } from 'react';

import { Button, Table } from 'antd';
import moment from 'moment';
import { useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { T } from 'react-translator-component';
import styled from 'styled-components';

import { getChargingProfiles } from '../../../hooks/profiles';
import { COLORS } from '../../../utils/theme/colors';
import { ListPagination } from '../ListPagination/ListPagination';

const ChargingProfileList = (): any => {
  const [chargingProfileList, setChargingProfileList] = useState<any>({});
  const [paginatedProfiles, setPaginatedProfiles] = useState<any[]>([]);
  const paginationRef = useRef<any>();

  const history = useHistory();

  const routes = useSelector((state: any) => state.user.routes);

  const columns = [
    {
      title: T('Charging Profile PK'),
      dataIndex: 'chargingProfilePk',
      key: 'chargingProfilePk',
      render: (text) => <a>{text}</a>,
    },
    {
      title: T('Description'),
      dataIndex: 'description',
      key: 'description',
    },
    {
      title: T('Stack Level'),
      dataIndex: 'stackLevel',
      key: 'stackLevel',
    },
    {
      title: T('Profile Purpose'),
      dataIndex: 'profilePurpose',
      key: 'profilePurpose',
    },
    {
      title: T('Profile Kind'),
      dataIndex: 'profileKind',
      key: 'profileKind',
    },
    {
      title: T('Recurrency Kind'),
      dataIndex: 'recurrencyKind',
      key: 'recurrencyKind',
    },
    {
      title: T('Edit'),
      dataIndex: 'edit',
      key: 'edit',
      render: (text) => {
        return Object.keys(
          routes &&
            routes.find(({ path }) => path === '/charging_profile/edit/:id'),
        ).length ? (
          <Button
            onClick={() => {
              history.push(
                `/charging_profile/edit/${
                  chargingProfileList.list.find(
                    (profile) => profile.chargingProfilePk === text,
                  ).chargingProfilePk
                }`,
              );
            }}
          >
            {T('Edit/ See Details')}
          </Button>
        ) : (
          <span>{T('Not allowed')}</span>
        );
      },
    },
  ];

  useEffect(() => {
    (async () => {
      if (!Object.keys(chargingProfileList).length)
        setChargingProfileList(await getChargingProfiles());
    })();
  });
  return (
    <ChargingProfileListWrapper>
      <ChargingProfileListFlexRow>
        <div>
          <span className='box_title'>{T('Charging Profiles')}</span>
          {Object.keys(
            routes.find(({ path }) => path === '/charging_profile/create'),
          ).length ? (
            <Button
              style={{ marginLeft: '1em' }}
              onClick={() => history.push('/charging_profile/create')}
            >
              {T('Add new charging profile')}
            </Button>
          ) : null}
          <Container>
            <Table
              style={{ minWidth: '400px' }}
              size='small'
              pagination={false}
              columns={columns}
              dataSource={paginatedProfiles?.map((profile: any, index: any) => {
                return {
                  key: index,
                  chargingProfilePk: profile.chargingProfilePk,
                  description: profile.description,
                  stackLevel: profile.stackLevel,
                  profilePurpose: profile.profilePurpose,
                  profileKind: profile.profileKind,
                  recurrencyKind: profile.recurrencyKind,
                  validFrom: moment(profile.validFrom).format('YYY-MM-DD'),
                  validTo: moment(profile.validTo).format('YYYY-DD-MM'),
                  edit: profile.chargingProfilePk,
                };
              })}
            />
            {chargingProfileList?.list?.length > 0 && (
              <ListPagination
                ownRef={paginationRef}
                pureData={chargingProfileList.list}
                callback={(newPageData) => setPaginatedProfiles(newPageData)}
              />
            )}
          </Container>
        </div>
      </ChargingProfileListFlexRow>
    </ChargingProfileListWrapper>
  );
};

const ChargingProfileListWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: stretch;
  justify-content: flex-start;
  padding: 2em;
`;

const ChargingProfileListFlexRow = styled.div`
  display: flex;
  flex-direction: row;
  align-items: stretch;
  justify-content: flex-start;
  flex-wrap: wrap;
  max-width: 1000px;
`;

const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  border: 1px solid ${COLORS.stone};
  border-radius: 2px;
  margin: 0.5em 1em 0.5em 0;
  padding: 1em;
`;

export default ChargingProfileList;
